/*
 * @Author: 无名
 * @Date: 2021-08-19 19:34:43
 * @LastEditTime: 2021-10-21 17:54:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \鲁南\src\modules\fire\router.js
 */
// 模块名称：消防管理-消防管理-消防控制// 备注：一级菜单-二级菜单，该系统可能菜单嵌套过多，建议书写完整
//{
//   path: '/fireControl',//路由路径：二级路由，如果是三级路由/fireControl/xxxx，以此类推
//   name: 'fireControl',//路由名称，二级名称，如果是三级名称则fireControl_xxxx
//   component: () => import('@src/modules/fire/view/fireControlNew'),//推荐使用该方式即es6的懒加载方式，
//   webpack的懒加载：component: resolve=>require(["@/components/pages/signIn/signIn"],resolve),
//   meta: {  //路由的元信息，可以用来储存一些当前路由的自定义数据：如requireAuth，routerAlive
//     requireAuth: false,//是否需要权限
//     module: "fireControl",//所属模块，由于该系统后台配置的路径是一级路由，二级三级等子级路由需根据该字段判断
//     routerAlive: true,//是否做缓存组件
//   }
// },
const routes = [
  // 消防管理-消防管理-消防控制
  {
    path: '/fireControl',//二级路由
    name: 'fireControl',
    component: () => import('@src/modules/fire/view/fireControlNew'),
    meta: {
      requireAuth: false,
      module: "fireControl",
      routerAlive: true
    }
  },
  // 消防管理-消防管理-控制记录
  {
    path: '/fireControlRecord',
    name: 'fireControlRecord',
    component: () => import('@src/modules/fire/view/fireControlRecord'),
    meta: {
      requireAuth: false,
      module: "fireControlRecord",
      routerAlive: true
    }
  },
  // 消防管理-消防管理-消防告警
  {
    path: '/fireAlarm',
    name: 'fireAlarm',
    component: () => import('@src/modules/fire/view/fireAlarm'),
    meta: {
      module: "fireAlarm",
      requireAuth: false,
      // routerAlive: true,

    }
  },
  // 消防管理-消防管理-消防历史告警记录
  {
    path: '/fireHistory',
    name: 'fireHistory',
    component: () => import('@src/modules/fire/view/fireHistory'),
    meta: {
      module: "fireHistory",
      requireAuth: false
    }
  },
    // 消防管理-消防管理-消防监控
  {
    path: '/fireMonitor',
    name: 'fireMonitor',
    component: () => import('@src/modules/fire/view/fireMonitor'),
    meta: {
      module: "fireMonitor",
      requireAuth: false
    }
  },
  // 消防管理-消防管理-消防事件工单
  {
    path: '/fireTaskCenter/list',
    name: 'fireWorkOrder',
    component: () => import('@src/modules/fire/view/fireWorkOrder'),
    meta: {
      module: "fireWorkOrder",
      requireAuth: false
    }
  }
]

export default routes
